import { AccountInfoStateType } from '@central-products/interface-account-info';
import { subscribe } from '@wh/message-bus';

import { ACCOUNT_INFO_STATE_CHANGED_EVENT } from '../../topics';

function waitForVisitorId(maxRetries) {
  const oldVal = window.utag && window.utag.dle_visitor_id;
  return new Promise((resolve) => {
    let count = 0;
    const id = setInterval(() => {
      const newVal = window.utag && window.utag.dle_visitor_id;
      if (newVal !== oldVal || count >= maxRetries) {
        clearInterval(id);
        resolve(newVal);
        return;
      }
      count++;
    }, 500);
  });
}

function waitForLivePersonClient(maxRetries) {
  return new Promise((resolve) => {
    let client = window.WH && window.WH.LivePerson && window.WH.LivePerson.client;
    if (client) {
      resolve(client);
      return;
    }

    let count = 0;
    const id = setInterval(() => {
      client = window.WH && window.WH.LivePerson && window.WH.LivePerson.client;
      if (client) {
        clearInterval(id);
        resolve(client);
        return;
      }
      if (count >= maxRetries) {
        clearInterval(id);
        resolve(null);
        return;
      }
      count++;
    }, 500);
  });
}

function fetchAndSetAudiences(visitorId, params) {
  const CALLBACK_NAME = 'setAudiences';
  let count = 0;

  function fetchAudiences() {
    const script = document.createElement('script');
    script.onload = function onload() {
      script.parentNode.removeChild(script);
    };
    script.src =
      params.visitorServiceUrl.replace('$(visitorId)', visitorId) +
      `?callback=window.HEADER_RENDER_SERVICE.${CALLBACK_NAME}&rnd=${new Date().getTime()}`;
    document.body.appendChild(script);
  }

  window.HEADER_RENDER_SERVICE[CALLBACK_NAME] = async function syncAudiencesCb(data) {
    count++;
    if (!data.audiences) {
      if (count < 10) {
        fetchAudiences();
      }
      return;
    }
    const audiences = Object.values(data.audiences);
    await waitForLivePersonClient(100);
    window.WH.LivePerson.client.setAudiences(audiences);
    window.WH.LivePerson.client.refresh(audiences);
  };

  fetchAudiences();
}

export function syncAudiencesViaVisitorService(params) {
  return subscribe({
    topic: ACCOUNT_INFO_STATE_CHANGED_EVENT,
    callback: async ({ data }) => {
      if (data.state !== AccountInfoStateType.ACCOUNT_INFO_EXISTS) {
        return;
      }

      const visitorId = await waitForVisitorId(params.visitorIdMaxRetries);
      await fetch(params.tealiumInitUrl.replace('$(visitorId)', visitorId));
      fetchAndSetAudiences(visitorId, params);
    },
  });
}
